export enum KnownMediums {
  influencer = 'influencer',
  walkin = 'walk-in',
  website = 'website',
  integration = 'integration',
  appstore = 'appstore',
  webapp = 'webapp',
  friend = 'friend',
  friendinvite = 'friendinvite',
  workoutInvite = 'workoutInvite',
}

export enum KnownSources {
  tests = 'tests',
  freebooking = 'free-booking',
  activecampaign = 'active-campaign',
  appleappstore = 'appleappstore',
  googleplay = 'googleplay',
  fitillioncom = 'app.fitillion.com',
  classPass = 'class-pass',
}
